import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { h6 } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Item = styled(m.div) `
  color: var(--titleColour, ${brand.blue.navy});
  padding: ${fluid(16, 18)} ${fluid(12, 18)};

  &:not(:last-of-type) {
    margin-bottom: ${fluid(0, 16)};
    border-bottom: 1px solid ${brand.grey.light};

    @media ${from(Device.TabletLarge)} {
      border-bottom: none;
    }
  }

  @media ${from(Device.TabletLarge)} {
    border-bottom: none;
  }
`;
const ItemHeader = styled.button `
  ${ButtonReset};

  display: flex;
  align-items: flex-start;
  text-align: left;
  width: 100%;
  color: currentColor;
  gap: 8px;

  @media ${from(Device.TabletLarge)} {
    align-items: center;
  }

  &.focus-ring {
    outline: auto;
  }
`;
const ItemTitle = styled.h3 `
  ${h6};
  margin-bottom: 0;

  display: block;
  flex: 1 1 auto;
`;
const ItemIcon = styled(m.span) `
  display: block;
  flex: 0 0 auto;
  height: 11px;
  margin-left: auto;
  width: 18px;
  margin-top: 4px;

  @media ${from(Device.TabletLarge)} {
    margin-top: 0;
  }

  svg {
    display: block;
    width: 100%;
  }
`;
const ItemBody = styled(m.div) `
  min-width: 0;
  overflow: hidden;
`;
export default {
    Item,
    ItemBody,
    ItemHeader,
    ItemIcon,
    ItemTitle,
};
